'use strict';

module.exports = {
    PLAYER_SPEED: 300,
    MAPS_TIME_LIMIT: 5
};
